export default __webpack_public_path__ + "media/images/wave-be6abb0a.png";